import { useState } from 'react';

import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';

import { useToast } from 'hooks/useToast';
import { apiOrchestrator } from 'services/apiService';

const forgotPasswordSchema = yup.object().shape({
  email: yup.string().email('E-mail inválido').required('E-mail é obrigatório'),
});

export const useForgotPassword = () => {
  const [loading, setLoading] = useState(false);
  const { toastSuccess, toastError } = useToast();

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(forgotPasswordSchema),
  });

  const onSubmit = async (data: any): Promise<{ success: boolean }> => {
    setLoading(true);
    try {
      const response = await apiOrchestrator.post('/auth/forgot_password', {
        email: data.email,
      });
      if (response.data.status === 'success') {
        toastSuccess('E-mail enviado com sucesso! Verifique seu e-mail.');
        setLoading(false);
        return { success: true };
      }
    } catch (error) {
      toastError('Erro ao enviar o e-mail. Por favor, tente novamente.');
      setLoading(false);
    }
    return { success: false };
  };

  return {
    control,
    errors,
    handleSubmit,
    onSubmit,
    loading,
  };
};
